export class Timer {

    private _stopped: boolean = true;
    private _start: number = 0;
    private _end: number = 0;

    get stopped(): boolean {
        return this._stopped;
    }

    start(): void {
        this._stopped = false;
        this._start = Date.now();
    }

    elapsedMilliseconds(): number {
        if (!this._stopped) {
            return Date.now() - this._start;
        }
        return this._end - this._start;
    }

    stop(): void {
        this._stopped = true;
        this._end = Date.now();
    }
}
